import {
  GPX_CAPABILITIES,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_ROUTES,
  gspx,
} from '@rsos/gainsight';
import type { PreconfiguredResponse } from '@rsos/reduxDataStore/src/features/preconfiguredMessages/preconfiguredMessagesAPI';

const defaultTrackEvent = {
  type: GPX_EVENT_TYPES.CLICK,
  feature: GPX_FEATURES.TF911_PRECONFIGURED_RESPONSES,
  capability: GPX_CAPABILITIES.TF911,
  route: GPX_ROUTES.COMMUNICATOR,
};

export const trackViewAllPreconfiguredResponses = (conversationID: string) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'open_preconfigured_responses',
    entities: {
      conversationID: conversationID,
    },
  });
};

export const trackCloseAllMessagesModal = (conversationID: string) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'close_preconfigured_responses',
    entities: {
      conversationID: conversationID,
    },
  });
};

export const trackSendPreconfiguredResponse = (
  message: PreconfiguredResponse,
  conversationID: string,
) => {
  gspx.trackEvent({
    ...defaultTrackEvent,
    name: 'send_preconfigured_response',
    entities: {
      title: message.title,
      body: message.body,
      id: message.id,
      conversationID: conversationID,
    },
  });
};
